import { render, staticRenderFns } from "./Secion_vencida.vue?vue&type=template&id=5136db7e"
import script from "./Secion_vencida.vue?vue&type=script&lang=js"
export * from "./Secion_vencida.vue?vue&type=script&lang=js"
import style0 from "./Secion_vencida.vue?vue&type=style&index=0&id=5136db7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports